module.exports = __webpack_public_path__ + "static/img/Dog-3.b297e421.png";